/* Scene clips load only after a visitor presses play. */
if (!window.rwSceneVideoBound) {
  window.rwSceneVideoBound = true;
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-rw-scene-play]');
    if (!button) return;
    const video = button.parentElement.querySelector('.rw-scene-video');
    if (!video || !button.dataset.src) return;
    document.querySelectorAll('.rw-scene-video').forEach(function (other) {
      if (other !== video) other.pause();
    });
    video.src = button.dataset.src;
    video.hidden = false;
    button.hidden = true;
    video.play().catch(function () {});
  });
  document.addEventListener('play', function (event) {
    if (!event.target.matches('.rw-scene-video')) return;
    document.querySelectorAll('.rw-scene-video').forEach(function (other) {
      if (other !== event.target) other.pause();
    });
  }, true);
}

/* Manual photo carousel; no autoplay. */
if (!window.rwSceneCarouselBound) {
  window.rwSceneCarouselBound = true;
  function updateSceneControls(section) {
    const track = section.querySelector("[data-rw-scene-track]");
    if (!track) return;
    const previous = section.querySelector("[data-rw-scene-prev]");
    const next = section.querySelector("[data-rw-scene-next]");
    if (previous) previous.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  }
  function updateAllSceneControls() {
    document.querySelectorAll("[data-rw-scene-carousel]").forEach(updateSceneControls);
  }
  document.addEventListener("click", function (event) {
    const button = event.target.closest("[data-rw-scene-prev], [data-rw-scene-next]");
    if (!button) return;
    const section = button.closest("[data-rw-scene-carousel]");
    const track = section && section.querySelector("[data-rw-scene-track]");
    const tile = track && track.querySelector(".rw-scene-tile");
    if (!track || !tile) return;
    const step = tile.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
    const direction = button.hasAttribute("data-rw-scene-next") ? 1 : -1;
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    track.scrollBy({ left: direction * step, behavior: reducedMotion ? "auto" : "smooth" });
  });
  document.addEventListener("scroll", function (event) {
    if (event.target.matches && event.target.matches("[data-rw-scene-track]")) {
      updateSceneControls(event.target.closest("[data-rw-scene-carousel]"));
    }
  }, true);
  window.addEventListener("resize", updateAllSceneControls);
  document.addEventListener("shopify:section:load", updateAllSceneControls);
  updateAllSceneControls();
}
